import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useReveal } from './Reveal';
import { HISTORY_TIMELINE } from '../data/science';

// Minimalist vertical timeline (brand-free historical context).
const Timeline = () => {
  const { lang } = useLang();
  const { ref, visible } = useReveal({ threshold: 0.1 });

  return (
    <ol ref={ref} className="relative border-l border-slate-200 ml-2" data-testid="history-timeline">
      {HISTORY_TIMELINE.map((item, i) => (
        <li
          key={i}
          className="relative pl-7 pb-8 last:pb-0"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'none' : 'translateY(10px)',
            transition: `opacity 0.5s ease ${i * 70}ms, transform 0.5s ease ${i * 70}ms`,
          }}
        >
          <span className="absolute -left-[6.5px] top-1 w-3 h-3 rounded-full bg-blue-700 ring-4 ring-white" aria-hidden="true" />
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-blue-700">{item.era[lang]}</p>
          <p className="mt-1.5 text-[14px] text-slate-600 leading-relaxed max-w-2xl">{item.text[lang]}</p>
        </li>
      ))}
    </ol>
  );
};

export default Timeline;
